<template>
	<div
		v-bind:class="[
			'btn-group',
			'push-15',
			'button-group',
			'text-nowrap',
			{
				'btn-group-justified': justified
			}
		]"
	>
		<div
			v-if="justified"
			v-for="(val, key) in values" :key="key"
			class="btn-group">
			<button
				type="button"
				@click="selected = key; $emit('change', key)"
				v-bind:disabled="disabled"
				v-bind:class="[
					'btn',
					{
						'btn-lg': size == 'lg',
						'btn-sm': size == 'sm',
						'btn-primary btn-selected': selected == key,
						'btn-fill': selected == key,
						'btn-default': selected != key,
						'margin': margin == 'lg',
					}
				]"
				v-html="val"></button>
		</div>

		<button
			v-if="!justified"
			v-for="(val, key) in values" :key="key"
			type="button"
			@click="selected = key; $emit('change', key)"
			v-bind:disabled="disabled"
			v-bind:class="[
				'btn',
				{
					'btn-lg': size == 'lg',
					'btn-sm': size == 'sm',
					'btn-primary btn-selected': selected == key,
					'btn-fill': selected == key,
					'btn-default': selected != key
				}
			]"
			v-html="val"></button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selected: this.value,
			}
	    },
	    props: {
			size: {
    			default: 'lg',
    			type: String
			},
			justified: {
				default: true,
    			type: Boolean
			},
			margin: {
				default: '',
				type: String
			},
			values: {},
			value: {},
			name: {},
			disabled: {},
		},
	    watch: {
	        value: function (data) {
	            this.selected = data
	        },
	    },
	}
</script>

<style lang="scss">
    .button-group {
        .btn {
			float: none;
		}
	}
	.button-group{
		.margin {
			margin-right: 8px;
		}
	}
</style>